import React, {
  forwardRef,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react'

import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import {
  BagFill,
  BuildingFillAdd,
  GearFill,
  Hr,
  ListCheck,
} from 'react-bootstrap-icons'

import Navbar from '../../../components/navbar/navbar'

import { Addresses } from './pages/Addresses'
import { Configuration } from './pages/Configuration'
import { Division } from './pages/Division'
import { OS } from './pages/OS'

import { CustomSpinner } from '../../CustomSpinner'
import { Products } from './pages/Products'
import {
  Container,
  ContainerLoading,
  Content,
  Form,
  Sidebar,
  Step,
} from './styles'

const INITIAL_STATE = {
  info: {
    id: '',
    descricao: '',
    tipo: 'E',
    considera_estoque: 'S',
    conferencia_cega: 'S',
    observacoes: '',
  },
  isConfigConfirmed: false,
  addresses: [],
  isAddressesConfirmed: false,
  isDivisionConfirmed: false,
}

export const FormWMSInventario = forwardRef(({ isLoading }, ref) => {
  const [inventory, setInventory] = useState(INITIAL_STATE)
  const [sidebarType, setSidebarType] = useState('min')
  const [activeSidebar, setActiveSidebar] = useState(0)

  const sidebarOptions = useMemo(() => {
    return [
      {
        value: 'settings',
        label: 'Config.',
        icon: (
          <GearFill
            color="white"
            size={20}
          />
        ),
      },
      {
        value: inventory.info.tipo === 'E' ? 'addresses' : 'products',
        label: inventory.info.tipo === 'E' ? 'Endereços' : 'Produtos',
        icon:
          inventory.info.tipo === 'E' ? (
            <BuildingFillAdd
              color="white"
              size={20}
            />
          ) : (
            <BagFill
              color="white"
              size={20}
            />
          ),
      },
      {
        value: 'division',
        label: 'Divisão',
        icon: (
          <Hr
            color="white"
            size={20}
          />
        ),
      },
      {
        value: 'os',
        label: 'OS',
        icon: (
          <ListCheck
            color="white"
            size={20}
          />
        ),
      },
    ]
  }, [inventory.info.tipo])

  function handleNext() {
    return (
      activeSidebar <= sidebarOptions.length - 1 &&
      setActiveSidebar((prevState) => prevState + 1)
    )
  }

  useImperativeHandle(
    ref,
    () => ({
      sendData: ({ inventario, hasOrders }) => {
        setInventory({
          info: {
            id: inventario.id,
            descricao: inventario.descricao,
            tipo: inventario.tipo,
            considera_estoque: inventario.considera_estoque,
            conferencia_cega: inventario.conferencia_cega,
            observacoes: inventario.observacoes,
          },
          isConfigConfirmed: true,
          addresses: [],
          isAddressesConfirmed: hasOrders,
          isDivisionConfirmed: hasOrders,
        })
      },
    }),
    [],
  )

  return isLoading ? (
    <ContainerLoading>
      <div>
        <CustomSpinner size={40} />
        <h1>Carregando informações...</h1>
      </div>
    </ContainerLoading>
  ) : (
    <>
      <Navbar />

      <Container className="mt-page">
        <h4>Inventário</h4>

        <Content>
          <Sidebar
            onDoubleClick={() =>
              setSidebarType((prevState) =>
                prevState === 'min' ? 'max' : 'min',
              )
            }
          >
            {sidebarOptions.map((opt, index) => {
              if (!opt) {
                return null
              } else {
                return (
                  <React.Fragment key={opt?.value}>
                    {sidebarType === 'min' ? (
                      <OverlayTrigger overlay={<Tooltip>{opt?.label}</Tooltip>}>
                        <Step
                          selected={activeSidebar == index}
                          onClick={() => {
                            setActiveSidebar(index)

                            window.scrollTo({
                              top: 0,
                              behavior: 'smooth',
                            })
                          }}
                        >
                          {opt?.icon}
                          {sidebarType !== 'min' && <h3>{opt?.label}</h3>}
                        </Step>
                      </OverlayTrigger>
                    ) : (
                      <>
                        {index == 0 ? (
                          <OverlayTrigger
                            overlay={
                              <Tooltip>Dois cliques para minimizar</Tooltip>
                            }
                          >
                            <Step
                              selected={activeSidebar == index}
                              onClick={() => {
                                setActiveSidebar(index)

                                window.scrollTo({
                                  top: 0,
                                  behavior: 'smooth',
                                })
                              }}
                            >
                              {opt?.icon}
                              {sidebarType !== 'min' && <h3>{opt?.label}</h3>}
                            </Step>
                          </OverlayTrigger>
                        ) : (
                          <Step
                            selected={activeSidebar == index}
                            onClick={() => {
                              setActiveSidebar(index)

                              window.scrollTo({
                                top: 0,
                                behavior: 'smooth',
                              })
                            }}
                          >
                            {opt?.icon}
                            {sidebarType !== 'min' && <h3>{opt?.label}</h3>}
                          </Step>
                        )}
                      </>
                    )}
                  </React.Fragment>
                )
              }
            })}
          </Sidebar>

          <Form>
            {activeSidebar === 0 && (
              <Configuration
                inventory={inventory}
                setInventory={setInventory}
                onNext={handleNext}
              />
            )}

            {activeSidebar === 1 &&
              (inventory.info.tipo === 'E' ? (
                <Addresses
                  inventory={inventory}
                  setInventory={setInventory}
                  onNext={handleNext}
                />
              ) : (
                <Products
                  inventory={inventory}
                  setInventory={setInventory}
                  onNext={handleNext}
                />
              ))}

            {activeSidebar === 2 && (
              <Division
                inventory={inventory}
                setInventory={setInventory}
                onNext={handleNext}
              />
            )}

            {activeSidebar === 3 && (
              <OS
                inventory={inventory}
                setInventory={setInventory}
                onNext={handleNext}
              />
            )}
          </Form>
        </Content>
      </Container>
    </>
  )
})
